import api from '../irelandApi';

const STORE_PERFORMANCES_URL = '/api/store_performances';

// eslint-disable-next-line import/prefer-default-export
export const getStorePerformances = (outletId = null) => (dispatch) => {
  dispatch({type: 'GET_STORE_PERFORMANCE_DATA_PENDING', payload: []});
  const url = outletId ? `${STORE_PERFORMANCES_URL}?outlet_id=${outletId}` : STORE_PERFORMANCES_URL;
  return api
    .get(url)
    .then((response) => {
      dispatch({type: 'GET_STORE_PERFORMANCE_DATA_FULFILLED', payLoad: response.data.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_STORE_PERFORMANCE_DATA_REJECTED', payLoad: error.response});
    });
};
